import { createContext, useContext, useCallback, useRef, useMemo } from "react";
import { getSessionId } from "../utils/getSessionId";
import api from "../configs/api";

export const AnalyticsContext = createContext(null);

export const AnalyticsProvider = ({ children }) => {
  const sessionId = useMemo(() => getSessionId(), []);
  const lastSent = useRef(0);

  const sendEvent = useCallback(
    async (propertyId, eventType) => {
      if (!propertyId) return;
      const now = Date.now();
      if (now - lastSent.current < 400) return;
      lastSent.current = now;
      try {
        await api.post(`/analytics/event/${propertyId}`, {
          sessionId,
          eventType,
        });
      } catch (error) {
        console.error("Event log failed", error);
      }
    },
    [sessionId]
  );

  const logEvent = useMemo(
    () => ({
      impression: (id) => sendEvent(id, "impression"),
      viewClick: (id) => sendEvent(id, "view_click"),
      view: (id) => sendEvent(id, "view"),
      contactClick: (id) => sendEvent(id, "contact_click"),
      phoneReveal: (id) => sendEvent(id, "phone_reveal"),
      whatsapp: (id) => sendEvent(id, "whatsapp_click"),
      share: (id) => sendEvent(id, "share"),
      leadGenerated: (id) => sendEvent(id, "lead_generated"),
    }),
    [sendEvent]
  );

  return (
    <AnalyticsContext.Provider value={{ logEvent, sessionId }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
